import { DELIVERY_TYPE, DINEIN_TYPE, PICKUP_TYPE } from '../webStorage/keys/sessionKeys';
import { getOrderType } from '../webStorage/manageOrderType';

export const isEligibleForOrderType = (binaryCode, order_type) => {
  binaryCode = Number(binaryCode);
  const orderType = order_type || getOrderType();
  if (orderType == DINEIN_TYPE) {
    return (binaryCode & 1) === 1;
  } else if (orderType == DELIVERY_TYPE) {
    return (binaryCode & 2) === 2;
  } else if (orderType == PICKUP_TYPE) {
    return (binaryCode & 4) === 4;
  }
};
